import styled from 'styled-components';

export const MainLabel = styled.h2`
  padding: 1.9rem 0;
`;

// ============= ============= ============= ============= =============

export const Select = styled.select``;
